import React, { useContext } from 'react';
import styles from './NewLeaderboardContainer.module.css';
import handleImageError from '../../../helper/defaultImage';
import { baseUrl, dataContext } from '../../../App';

const CurrentUserCard = ({ currentUserData }) => {
  const { playerData } = useContext(dataContext);
  if (!currentUserData?.User_Rank || currentUserData?.User_Rank === "0") {
    return null;
  }

  return (
    <div className={styles.currentUserSection}>
      <div className={styles.userRow} style={{ boxShadow: 'none' }}>
        <div className={styles.rank}>{currentUserData?.User_Rank ?? '-'}</div>
        <img
          src={playerData?.avatar_img 
            ? `${baseUrl}${playerData?.avatar_img}` 
            : require(`../../../assets/avatar/avatar${playerData?.avatar_id || 1}.png`)}
          alt="User"
          className={styles.userAvatar}
          onError={handleImageError}
        />
        <div className={styles.userInfo}>
          <div className={styles.userMsisdn}>{`আপনার স্কোর`}</div>
          <div className={styles.timeAndScore}>
            <span>{currentUserData?.time_taken ?? '-'}s</span>
            <span>{currentUserData?.score ?? '-'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentUserCard; 